"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateEnquiryStatusResponseDto = instanceOfUpdateEnquiryStatusResponseDto;
exports.UpdateEnquiryStatusResponseDtoFromJSON = UpdateEnquiryStatusResponseDtoFromJSON;
exports.UpdateEnquiryStatusResponseDtoFromJSONTyped = UpdateEnquiryStatusResponseDtoFromJSONTyped;
exports.UpdateEnquiryStatusResponseDtoToJSON = UpdateEnquiryStatusResponseDtoToJSON;
exports.UpdateEnquiryStatusResponseDtoToJSONTyped = UpdateEnquiryStatusResponseDtoToJSONTyped;
var UpdateEnquiryStatusResponseDataDto_1 = require("./UpdateEnquiryStatusResponseDataDto");
/**
 * Check if a given object implements the UpdateEnquiryStatusResponseDto interface.
 */
function instanceOfUpdateEnquiryStatusResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function UpdateEnquiryStatusResponseDtoFromJSON(json) {
    return UpdateEnquiryStatusResponseDtoFromJSONTyped(json, false);
}
function UpdateEnquiryStatusResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, UpdateEnquiryStatusResponseDataDto_1.UpdateEnquiryStatusResponseDataDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function UpdateEnquiryStatusResponseDtoToJSON(json) {
    return UpdateEnquiryStatusResponseDtoToJSONTyped(json, false);
}
function UpdateEnquiryStatusResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, UpdateEnquiryStatusResponseDataDto_1.UpdateEnquiryStatusResponseDataDtoToJSON)(value['data']),
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
